export const achievements = [
  {
    text: 'Won hackathon arranged by Campus Varberg, Sweden. - 2026',
    url: 'https://campus.varberg.se/evenemang/391-hackathon'
  },
  {
    text: 'Achieved Sweden Institute Scholarship for Global Professionals - 2025',
    url: 'https://si.se/en/apply/scholarships/swedish-institute-scholarships-for-global-professionals/'
  },
  {
    text: 'Won hackathon arranged by High Five - 2025',
    url: 'https://highfive.se/'
  },
  {
    text: 'Placed 18th in an international hackathon on Machine Learning organized by Her Will.',
    url: 'https://www.kaggle.com/competitions/her-will-ai-for-equality-datathon-2024/leaderboard'
  },
  {
    text: 'Placed 3rd in Code Jam 2016 in an intra-university (Stamford University) contest.'
  },
  {
    text: 'Placed 55th in ICPC Dhaka Regional Contest 2015.'
  }
];
